module.exports = "<div *ngIf=\"message\" [ngClass]=\"{ 'alert': message, 'alert-success': message.type === 'success', 'alert-danger': message.type === 'error','alert-fade':fade }\">{{message.text}}</div>\r\n"


//////////////////
// WEBPACK FOOTER
// E:/Release/InzuzoA/InzuzoA/src/app/_directives/alert.component.html
// module id = ../../../../../src/app/_directives/alert.component.html
// module chunks = main